export interface AssessmentOption {
  label: string
  score: number
  description: string
}

export interface AssessmentQuestion {
  id: number
  category: string
  question: string
  options: AssessmentOption[]
}

export const ASSESSMENT_QUESTIONS: AssessmentQuestion[] = [
  {
    id: 1,
    category: '신체기능',
    question: '식사하기가 어떻게 되시나요?',
    options: [
      { label: '혼자서 가능', score: 0, description: '도움 없이 스스로 식사할 수 있음' },
      { label: '약간의 도움 필요', score: 1, description: '반찬을 잘라주거나 식사 준비만 도와주면 됨' },
      { label: '상당한 도움 필요', score: 2, description: '식사 중 계속 옆에서 도와줘야 함' },
      { label: '전적으로 도움 필요', score: 3, description: '다른 사람이 먹여드려야 함' },
    ],
  },
  {
    id: 2,
    category: '신체기능',
    question: '옷 갈아입기와 세수하기는 어떤가요?',
    options: [
      { label: '혼자서 가능', score: 0, description: '스스로 옷을 갈아입고 세수할 수 있음' },
      { label: '약간의 도움 필요', score: 1, description: '단추나 지퍼 등 일부분만 도와주면 됨' },
      { label: '상당한 도움 필요', score: 2, description: '대부분 도움이 필요하지만 협조는 가능' },
      { label: '전적으로 도움 필요', score: 3, description: '다른 사람이 전부 해줘야 함' },
    ],
  },
  {
    id: 3,
    category: '신체기능',
    question: '걷기와 이동하기는 어떤가요?',
    options: [
      { label: '혼자서 가능', score: 0, description: '보조기구 없이 실내외 이동 가능' },
      { label: '보조기구 사용', score: 1, description: '지팡이, 보행기 등을 사용하면 이동 가능' },
      { label: '부축 필요', score: 2, description: '다른 사람이 부축해야 이동 가능' },
      { label: '이동 불가', score: 3, description: '침대에서 일어나지 못하거나 휠체어 필요' },
    ],
  },
  {
    id: 4,
    category: '인지기능',
    question: '시간과 장소를 잘 인지하시나요?',
    options: [
      { label: '정상', score: 0, description: '날짜, 요일, 현재 장소를 정확히 알고 있음' },
      { label: '가끔 혼동', score: 1, description: '가끔 날짜나 장소를 혼동하지만 대부분 정상' },
      { label: '자주 혼동', score: 2, description: '집 안에서도 방을 헷갈리거나 계절을 모름' },
      { label: '심한 혼동', score: 3, description: '자신의 이름이나 가족을 알아보지 못함' },
    ],
  },
  {
    id: 5,
    category: '인지기능',
    question: '의사소통은 어떤가요?',
    options: [
      { label: '정상 대화 가능', score: 0, description: '일상적인 대화를 자연스럽게 할 수 있음' },
      { label: '간단한 대화 가능', score: 1, description: '간단한 질문에 답할 수 있지만 복잡한 대화는 어려움' },
      { label: '의사표현 어려움', score: 2, description: '단어 몇 개로만 의사를 전달하거나 잘 이해 못함' },
      { label: '소통 불가', score: 3, description: '의미 있는 의사소통이 거의 불가능' },
    ],
  },
  {
    id: 6,
    category: '행동변화',
    question: '이상행동(배회, 공격성 등)이 있나요?',
    options: [
      { label: '없음', score: 0, description: '특별한 이상행동이 없음' },
      { label: '가끔 발생', score: 1, description: '월 1~2회 정도 배회, 불안, 수면장애 등 발생' },
      { label: '자주 발생', score: 2, description: '주 1~2회 이상 배회, 공격적 언행 등 발생' },
      { label: '매일 발생', score: 3, description: '거의 매일 배회, 공격성, 망상 등으로 보호 필요' },
    ],
  },
  {
    id: 7,
    category: '간호처치',
    question: '투약이나 의료적 처치가 필요한가요?',
    options: [
      { label: '특별한 처치 없음', score: 0, description: '정기적인 의료 처치가 필요 없음' },
      { label: '투약 관리 필요', score: 1, description: '약을 정해진 시간에 챙겨 먹도록 도와줘야 함' },
      { label: '정기적 처치 필요', score: 2, description: '혈당 측정, 상처 소독 등 정기 관리 필요' },
      { label: '전문 간호 필요', score: 3, description: '경관영양, 욕창 관리, 도뇨관 등 전문 처치 필요' },
    ],
  },
  {
    id: 8,
    category: '재활',
    question: '일상생활의 전반적인 자립도는 어떤가요?',
    options: [
      { label: '대부분 자립', score: 0, description: '대부분의 일상 활동을 스스로 할 수 있음' },
      { label: '부분적 도움 필요', score: 1, description: '일부 활동에 도움이 필요하지만 기본 활동은 가능' },
      { label: '많은 도움 필요', score: 2, description: '대부분의 일상 활동에 도움이 필요' },
      { label: '전적 의존', score: 3, description: '거의 모든 활동에 타인의 도움이 필요' },
    ],
  },
]

/** 총점 → 예상 등급 매핑 */
export function getEstimatedGrade(totalScore: number): { grade: string; label: string; color: string; description: string } {
  if (totalScore >= 23) return { grade: '1등급', label: '장기요양 1등급', color: '#C92A2A', description: '일상생활에서 전적으로 다른 사람의 도움이 필요한 상태입니다.' }
  if (totalScore >= 20) return { grade: '2등급', label: '장기요양 2등급', color: '#D9480F', description: '일상생활에서 상당 부분 다른 사람의 도움이 필요한 상태입니다.' }
  if (totalScore >= 17) return { grade: '3등급', label: '장기요양 3등급', color: '#E67700', description: '일상생활에서 부분적으로 다른 사람의 도움이 필요한 상태입니다.' }
  if (totalScore >= 14) return { grade: '4등급', label: '장기요양 4등급', color: '#1864AB', description: '심신 기능이 일정 부분 저하되어 일상생활에 일부 도움이 필요한 상태입니다.' }
  if (totalScore >= 10) return { grade: '5등급', label: '장기요양 5등급', color: '#087F5B', description: '치매 등으로 일상생활에 부분적 도움이 필요한 상태입니다.' }
  if (totalScore >= 6) return { grade: '인지지원', label: '인지지원등급', color: '#5C7CFA', description: '치매 환자로서 일상생활에 일부 도움이 필요하지만 다른 등급에는 해당하지 않는 상태입니다.' }
  return { grade: '등급외', label: '등급 외', color: '#78716C', description: '현재 상태로는 장기요양등급에 해당하지 않을 가능성이 높습니다. 다만, 정확한 판정은 공단 방문조사를 통해 확인하세요.' }
}

/** 카테고리별 점수 집계 */
export function getCategoryScores(answers: Record<number, number>): { category: string; score: number; maxScore: number }[] {
  const categories = [
    { category: '신체기능', ids: [1, 2, 3] },
    { category: '인지기능', ids: [4, 5] },
    { category: '행동변화', ids: [6] },
    { category: '간호처치', ids: [7] },
    { category: '재활', ids: [8] },
  ]
  return categories.map(({ category, ids }) => ({
    category,
    score: ids.reduce((sum, id) => sum + (answers[id] ?? 0), 0),
    maxScore: ids.length * 3,
  }))
}
